import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {LinkSchema} from './link'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import * as z from 'zod'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {AssetItemSchema} from './assetItem'
import {IconLinkItemSchema} from './iconLinkItem'
import {ImageLinkItemSchema} from './imageLinkItem'
import {IconAssetLinkItemSchema} from './iconAssetLinkItem'
import {LabelAssetLinkItemSchema} from './labelAssetLinkItem'
import {PricingOptionSchema} from './pricingOption'
import {RiverBreakoutSchema} from './riverBreakout'
import {SubnavSchema} from './subnav'
import {faqGroupSchema} from './faqItem'

export const HeroVariantEnum = z.enum(['Stacked', 'Carousel', 'Icon Cards', 'Image Cards'])
export const FeatureDetailsEnum = z.enum(['Accordion', 'Stack'])
export const FeatureDetailsTwoEnum = z.enum(['Breakout', 'Carousel'])

export type HeroVariant = z.infer<typeof HeroVariantEnum>

export const TemplateFlexSuiteOverviewSchema = buildEntrySchemaFor('templateFlexSuiteOverview', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      // Hero
      heroHeading: RichTextSchema,
      heroLabel: z.string().optional(),
      heroDescription: safeOptional(RichTextSchema),
      heroCtaOne: LinkSchema,
      heroCtaTwo: safeOptional(LinkSchema),
      heroTertiaryDescription: safeOptional(RichTextSchema),
      // Variant fields
      heroVariant: safeOptional(HeroVariantEnum),
      heroImage: safeOptional(AssetSchema),
      heroCarousel: safeOptional(z.array(AssetItemSchema)),
      heroIconCards: safeOptional(z.array(IconLinkItemSchema)),
      heroImageCards: safeOptional(z.array(ImageLinkItemSchema)),
      // SubNav
      subNav: safeOptional(SubnavSchema),
      // Featured Content
      featureHeading: safeOptional(RichTextSchema),
      featureLabel: z.string().optional(),
      featureDescription: safeOptional(RichTextSchema),
      featureLink: safeOptional(LinkSchema),
      featureDetailsOne: safeOptional(FeatureDetailsEnum),
      featureRiverAccordion: safeOptional(z.array(IconAssetLinkItemSchema)),
      featureRiverStack: safeOptional(z.array(LabelAssetLinkItemSchema)),
      featureDetailsTwo: safeOptional(FeatureDetailsTwoEnum),
      featureRiverBreakout: safeOptional(RiverBreakoutSchema),
      featureBreakoutTabs: safeOptional(z.array(IconAssetLinkItemSchema)),
      // Pricing
      includePricingSection: safeOptional(z.boolean()),
      pricingHeading: safeOptional(RichTextSchema),
      pricingLabel: z.string().optional(),
      pricingDescription: safeOptional(RichTextSchema),
      pricingOptions: safeOptional(z.array(PricingOptionSchema)),
      pricingCtas: safeOptional(z.array(LinkSchema)),
      pricingTiles: safeOptional(z.array(z.string())),
      pricingTilesLead: safeOptional(RichTextSchema),
      //Outro Section
      outroFaqsHeading: safeOptional(RichTextSchema),
      outroFaqs: safeOptional(z.array(faqGroupSchema)),
    }),
  ),
})

export type TemplateFlexSuiteOverview = z.infer<typeof TemplateFlexSuiteOverviewSchema>
